import { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';

import { deleteHeartList } from 'actions/hearts';
import modalCSS from 'styles/components/common/modal.scss';
import css from 'styles/components/account/collectionModals/deleteCollectionModal.scss';

export class DeleteCollectionModal extends Component {
  static contextTypes = {
    testId: PropTypes.func
  };

  onDeleteCollection = () => {
    const { onDoneModal, deleteHeartList, listId } = this.props;
    deleteHeartList(listId).then(onDoneModal);
  }

  render() {
    const { showDeleteCollectionModal, onDoneModal } = this.props;

    return (
      <Modal className={cn(modalCSS.modalContent, css.modal)} overlayClassName={modalCSS.modalOverlay} isOpen={showDeleteCollectionModal}>
        <div>
          <div className={cn(modalCSS.header, css.header)}>
            <h2>Delete Collection?</h2>
            <button
              type="button"
              className={modalCSS.close}
              onClick={onDoneModal}
              aria-label="Close"
            />
          </div>

          <p>Are you sure you want to delete this collection?</p>

          <div className={css.footer}>
            <button type="button" onClick={onDoneModal}>Cancel</button>
            <button type="button" onClick={this.onDeleteCollection}>Delete</button>
          </div>
        </div>
      </Modal>
    );
  }
}

export const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  deleteHeartList
})(DeleteCollectionModal);
